export const storeTokens = (accessToken, refreshToken, legacyToken, userData, isAdmin = false) => {
  if (accessToken) localStorage.setItem('accessToken', accessToken);
  if (refreshToken) localStorage.setItem('refreshToken', refreshToken);
  if (legacyToken) localStorage.setItem('token', legacyToken); // backwards compatibility
  if (userData) localStorage.setItem(isAdmin ? 'admin' : 'user', JSON.stringify(userData));
};

export const getAccessToken = () => localStorage.getItem('accessToken');
export const getRefreshToken = () => localStorage.getItem('refreshToken');
export const getLegacyToken = () => localStorage.getItem('token');

export const getStoredUser = () => {
  const rawUser = localStorage.getItem('user');
  return rawUser ? JSON.parse(rawUser) : null;
};

export const getStoredAdmin = () => {
  const rawAdmin = localStorage.getItem('admin');
  return rawAdmin ? JSON.parse(rawAdmin) : null;
};

export const clearTokens = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('admin');
};
